/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { serviceTypes, ServiceTypes } from '@/constants/services';

import { modeType } from './mode';
import ServicesFactory from './servicesFactory';

const factory = new ServicesFactory(modeType);

const servicesMap = {
  [serviceTypes.REST]: factory.getRest(),
  [serviceTypes.QUERY]: factory.getQuery(),
  [serviceTypes.TIME]: factory.getTime(),
  [serviceTypes.LOCALIZE]: factory.getLocalize(),
} as const;

function InjectService(types: ServiceTypes[]) {
  return <T extends new (...args: any[]) => {}>(Base: T) =>
    class extends Base {
      constructor(...args: any[]) {
        super(
          ...args,
          types.map((type) => servicesMap[type]),
        );
      }
    };
}

export function ServicesMixin(types: ServiceTypes[]) {
  return InjectService(types);
}
